import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "grid-overlay"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  for: "grid",
  style: {"position":"fixed","bottom":"2px","left":"3rem","z-index":"9999","font-size":"10px","user-select":"none","cursor":"pointer","background-color":"blue","color":"#fff","padding":"2px 5px","border-radius":"2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($data.showComponent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($data.showGrid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_15))
          : _createCommentVNode("v-if", true),
        _createElementVNode("label", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            id: "grid",
            name: "grid",
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.showGrid) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, $data.showGrid]
          ]),
          _createTextVNode("Toggle Grid ")
        ])
      ]))
    : _createCommentVNode("v-if", true)
}